import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loadings from "../../components/Loadings/Loadings";
import fetchData from "utils/fetchData";
import stringUtilities from "utils/stringUtilities";
import ReportTemplateControls from "components/ReportTemplateControls";
import fetchUtils from 'utils/fetchData';

const PsaResultDetails = () => {
  const { id, applicantId } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState();

  const loadData = async () => {
    try {
      try {
        var pResult = await fetchData.Post('/api/hrmpsb/GetBeiResults', {
          ApplicantID: applicantId,
          JobPositionID: id,
          ForPsa: 1
        });
        pResult?.interviewers?.map(vItem => {
          pResult?.questions?.map(vQuestion => {
            var pScore = vQuestion.interviewers[vItem.interviewerID];
            pScore = stringUtilities.CDec2(pScore);
            if (pScore != 0)
              vItem.total = stringUtilities.CDec2(vItem.total) + stringUtilities.CDec2(pScore);
          });

          pResult.total = stringUtilities.CDec2(pResult.total) + stringUtilities.CDec2(vItem.total);
        });
        setResult(pResult);
      } catch (error) {
        console.log('Error in GetBackgroundInventigationeResults: ' + error)
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, []);
  const navigate = useNavigate();

  const ReportTemplateControls_onCreateXml = async () => {
    var pOut = await fetchUtils.Post("/api/Hrmpsb/GetBeiFormsXml", {
      jobPositionID: id,
      applicantID: applicantId,
      ForPsa: 1
    });
    return pOut;
  };

  const ReportTemplateControls_onCreatePdf = async () => {
    var pOut = await fetchUtils.Post("/api/Hrmpsb/CreateBeiFormsPdf", {
      jobPositionID: id,
      applicantID: applicantId,
      ForPsa: 1
    });
    return pOut;
  };

  return (
    <>
      {isLoading ? (
        <Loadings />
      ) : (
        <div className="">
          <button
            onClick={() => navigate(-1)}
            className="whitespace-nowrap hover:underline hover:text-blue-800 underline-offset-2"
          >
            Back
          </button>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Applicant: {result?.applicantName}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Job Position: {result?.jobPosition?.name}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Date Posted: {stringUtilities.FormatDate(result?.jobPosition?.postingDate)}
            </h1>
          </div>
          <div className="flex items-center gap-2 pt-2">
            <h1 className="font-semibold text-base">
              Applicant Deadline: {stringUtilities.FormatDate(result?.jobPosition?.applicationDeadline)}
            </h1>
          </div>

          <div className="flex justify-end mr-2">
            <ReportTemplateControls
              repxName="PsaForms"
              onCreateXml={ReportTemplateControls_onCreateXml}
              onCreatePdf={ReportTemplateControls_onCreatePdf}
            />
          </div>

          <table className="mt-4 border w-full max-h-[65vh]">
            <tr className="bg-primary">
              <th className="text-center text-white p-2 border">
                No.
              </th>
              <th className="text-center text-white p-2 border">
                Question
              </th>
              {result?.interviewers?.map(pInterviewer => {
                return <th className="text-center text-white p-2 border">
                  {pInterviewer.interviewerName}
                </th>
              })}
              <th className="text-center text-white p-2 border">
                Total
              </th>
            </tr>

            {result?.questions?.map((vQuestion, vIndex) => {
              return <tr key={vIndex}>
                <td className="p-2 border text-center">
                  {vIndex + 1}
                </td>
                <td className="p-2 border">
                  {vQuestion.criterion}
                </td>

                {result?.interviewers?.map(vInterviewer => {
                  return <td className="p-2 border text-center">
                    {vQuestion.interviewers[vInterviewer.interviewerID]}
                  </td>
                }) /* results?.questions?.map */}
                <td className="p-2 border text-center">
                  {vQuestion.total}
                </td>
              </tr>
            }) /* result?.raters?.map */}

            <tr className="bg-primary">
              <td colspan="2" className="text-center text-white p-2 border">Total</td>
              {result?.interviewers?.map(vInterviewer => {
                return <th className="text-center text-white p-2 border">
                  {vInterviewer.total}
                </th>
              })}
              <td className="text-center text-white p-2 border">{result?.total}</td>
            </tr>
          </table>

        </div>
      )}
    </>
  );
};

export default PsaResultDetails;